var map = {
	"./": "6912",
	"./apollo": "9716",
	"./apollo.js": "9716",
	"./device": "281f",
	"./device.js": "281f",
	"./index": "6912",
	"./index.js": "6912",
	"./routerAuth": "7834",
	"./routerAuth.js": "7834",
	"./tk": "daf2",
	"./tk.js": "daf2",
	"./user": "badc",
	"./user.js": "badc",
	"./vuexStorage": "9254",
	"./vuexStorage.js": "9254"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "326c";